/* Bellori v2 — global.js
   Tiroirs (menu/panier), panier AJAX, formulaire produit, pilules de taille,
   codes de réduction, description SEO repliable, barre sticky. Vanilla JS, zéro dépendance. */
(function () {
  'use strict';

  var FREE_AT = window.BelloriSettings && window.BelloriSettings.freeShippingThreshold || 5000; // en centimes

  function fmtMoney(cents) {
    var n = cents / 100;
    var s = Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Promo en cours (Paramètres du thème › Promo) : % posé par Liquid sur la carte / la fiche (data-promo-pct),
     annulé si le script de la barre promo (window.BelloriPromo) dit que la promo est terminée. */
  function promoPct(el) {
    var p = parseInt((el && el.getAttribute('data-promo-pct')) || '0', 10);
    if (!p) return 0;
    var P = window.BelloriPromo;
    if (P && P.active === false) return 0;
    return p;
  }
  function promoPrice(raw, pct) { return Math.round(raw * (100 - pct) / 100); }

  /* ---------- Tiroirs ---------- */
  var openDrawer = null;
  function setDrawer(id, open) {
    var wrap = qs('#' + id);
    if (!wrap) return;
    wrap.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    openDrawer = open ? id : null;
    if (open) {
      var panel = qs('[role="dialog"]', wrap);
      if (panel) panel.setAttribute('tabindex', '-1'), panel.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); setDrawer(t.getAttribute('data-drawer-open'), true); return; }
    var c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); setDrawer(c.getAttribute('data-drawer-close'), false); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) setDrawer(openDrawer, false);
  });

  /* ---------- Recherche repliable ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = qs('#bl-search-bar');
    if (!bar) return;
    bar.hidden = !bar.hidden;
    if (!bar.hidden) { var inp = qs('input[type="search"]', bar); if (inp) inp.focus(); }
  });

  /* ---------- Panier AJAX ---------- */
  function refreshCart(openAfter) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = qs('#bl-cart-drawer-content', tmp);
        var cur = qs('#bl-cart-drawer-content');
        if (fresh && cur) cur.replaceWith(fresh);
        var freshCount = qs('#bl-cart-count-src', tmp);
        if (freshCount) {
          qsa('[data-cart-count]').forEach(function (el) {
            el.textContent = freshCount.textContent.trim();
            el.setAttribute('data-count', freshCount.textContent.trim());
          });
        }
        if (openAfter) setDrawer('bl-cart', true);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form);
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(function () { return refreshCart(true); })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Impossible d’ajouter au panier.';
        var out = qs('[data-atc-error]', form);
        if (out) { out.textContent = msg; out.hidden = false; } else { alert(msg); }
      })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-change]');
    if (!t) return;
    e.preventDefault();
    var key = t.getAttribute('data-key');
    var qty = parseInt(t.getAttribute('data-qty'), 10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  });

  /* ---------- Code de réduction ---------- */
  function applyDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-promo-apply]');
    if (apply) {
      e.preventDefault();
      var input = qs('[data-promo-input]');
      var err = qs('[data-promo-error]');
      var code = input ? input.value.trim().toUpperCase() : '';
      if (!code) { if (err) { err.textContent = 'Entrez un code.'; err.hidden = false; } return; }
      applyDiscount(code).then(function (cart) {
        var codes = cart.discount_codes || [];
        var found = codes.filter(function (c) { return c.code.toUpperCase() === code; })[0];
        if (found && found.applicable) {
          refreshCart(false);
        } else {
          applyDiscount('');
          if (err) { err.textContent = 'Code inconnu ou expiré.'; err.hidden = false; }
        }
      });
      return;
    }
    var remove = e.target.closest('[data-promo-remove]');
    if (remove) {
      e.preventDefault();
      applyDiscount('').then(function () { refreshCart(false); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-promo-input]')) {
      e.preventDefault();
      var btn = qs('[data-promo-apply]');
      if (btn) btn.click();
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-promo-input]')) {
      e.target.value = e.target.value.toUpperCase();
      var err = qs('[data-promo-error]');
      if (err) err.hidden = true;
    }
  });

  /* ---------- Pilules de taille sur les cartes produit ---------- */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-card-variant]');
    if (!pill) return;
    e.preventDefault();
    var card = pill.closest('[data-product-card]');
    if (!card) return;
    qsa('[data-card-variant]', card).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    pill.setAttribute('aria-pressed', 'true');
    var d = pill.dataset;
    var priceEl = qs('[data-card-price]', card);
    var wasEl = qs('[data-card-was]', card);
    var promoEl = qs('[data-card-promo]', card);
    var imgEl = qs('[data-card-img]', card);
    var idEl = qs('input[name="id"]', card);
    var linkEls = qsa('[data-card-link]', card);
    var cpp = promoPct(card);
    var cPrice = parseInt(d.price, 10);
    var cCompare = parseInt(d.compare || '0', 10);
    if (cpp) { cCompare = Math.max(cCompare, cPrice); cPrice = promoPrice(cPrice, cpp); } // barré = prix catalogue, % = remise totale
    if (priceEl) priceEl.textContent = (d.from === 'true' ? 'Dès ' : '') + fmtMoney(cPrice);
    if (wasEl) {
      if (cCompare > cPrice) {
        wasEl.textContent = fmtMoney(cCompare);
        wasEl.hidden = false;
        if (promoEl) {
          promoEl.textContent = '−' + Math.round((1 - cPrice / cCompare) * 100) + ' %';
          promoEl.hidden = false;
        }
      } else {
        wasEl.hidden = true;
        if (promoEl) promoEl.hidden = true;
      }
    }
    if (imgEl && d.img) { imgEl.src = d.img; if (d.srcset) imgEl.srcset = d.srcset; }
    if (idEl) idEl.value = d.id;
    linkEls.forEach(function (a) { a.href = d.url; });
  });

  /* ---------- Formulaire produit ---------- */
  var buy = qs('[data-product-form]');
  if (buy) {
    var state = { qty: 1, pack: 'solo' };
    var duoDiscount = parseInt(buy.getAttribute('data-duo-discount') || '1500', 10);

    function currentVariant() {
      var checked = qs('[data-variant-pill][aria-pressed="true"]', buy);
      return checked ? checked.dataset : null;
    }
    /* Prix unitaire de la variante courante, promo appliquée (barré = prix catalogue, % = remise totale) */
    function unitBase() {
      var v = currentVariant();
      if (!v) return { price: 0, compare: 0 };
      var raw = parseInt(v.price, 10);
      var compare = parseInt(v.compare || '0', 10);
      var pp = promoPct(buy);
      if (pp) return { price: promoPrice(raw, pp), compare: Math.max(compare, raw) };
      return { price: raw, compare: compare };
    }
    function unitPrice() {
      var b = unitBase();
      return state.pack === 'duo' ? b.price * 2 - duoDiscount : b.price;
    }
    function unitWas() {
      var b = unitBase();
      var w = b.compare || b.price;
      return state.pack === 'duo' ? w * 2 : w;
    }
    function render() {
      var v = currentVariant();
      if (!v) return;
      var b = unitBase();
      var price = b.price;
      var compare = b.compare;
      var hasWas = compare > price;
      var pctLabel = '−' + Math.round((1 - price / compare) * 100) + ' %';
      var lineTotal = unitPrice() * state.qty;

      var set = function (sel, txt) { qsa(sel, document).forEach(function (el) { el.textContent = txt; }); };
      var show = function (sel, on) { qsa(sel, document).forEach(function (el) { el.hidden = !on; }); };

      set('[data-buy-price]', fmtMoney(price));
      if (hasWas) {
        set('[data-buy-was]', fmtMoney(compare));
        set('[data-buy-promo]', pctLabel);
        set('[data-buy-save]', 'Économisez ' + fmtMoney(compare - price));
      }
      show('[data-haswas]', hasWas);
      set('[data-buy-sizelabel]', v.title);
      set('[data-solo-price]', fmtMoney(price));
      set('[data-duo-price]', fmtMoney(price * 2 - duoDiscount));
      set('[data-duo-was]', fmtMoney(price * 2));
      set('[data-duo-per]', fmtMoney((price * 2 - duoDiscount) / 2));
      set('[data-buy-qty]', state.qty);
      set('[data-cta-price]', fmtMoney(lineTotal));
      set('[data-klarna-3x]', fmtMoney(Math.round(lineTotal / 3)));

      /* Barre sticky */
      set('[data-sticky-price]', fmtMoney(unitPrice()));
      if (hasWas) {
        set('[data-sticky-was]', fmtMoney(unitWas()));
        set('[data-sticky-promo]', pctLabel);
        set('[data-sticky-save]', 'Économisez ' + fmtMoney(unitWas() - unitPrice()));
      }
      set('[data-sticky-size]', v.title);

      /* Image variante dans la galerie */
      if (v.img) {
        qsa('[data-variant-img]').forEach(function (img) {
          img.src = v.img;
          if (v.srcset) img.srcset = v.srcset;
        });
      }

      /* Champs du formulaire */
      var idInput = qs('input[name="id"]', buy);
      if (idInput) idInput.value = v.id;
      var qtyInput = qs('input[name="quantity"]', buy);
      if (qtyInput) qtyInput.value = state.pack === 'duo' ? state.qty * 2 : state.qty;
      var packProp = qs('input[name="properties[Pack]"]', buy);
      if (packProp) packProp.disabled = state.pack !== 'duo';

      /* URL variante (deep-link) */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    document.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-variant-pill]');
      if (pill) {
        e.preventDefault();
        qsa('[data-variant-pill]', buy).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        pill.setAttribute('aria-pressed', 'true');
        render();
        return;
      }
      var pack = e.target.closest('[data-pack]');
      if (pack) {
        e.preventDefault();
        state.pack = pack.getAttribute('data-pack');
        qsa('[data-pack]').forEach(function (p) { p.setAttribute('aria-pressed', p === pack ? 'true' : 'false'); });
        render();
        return;
      }
      var inc = e.target.closest('[data-qty-inc]');
      if (inc) { e.preventDefault(); state.qty = Math.min(9, state.qty + 1); render(); return; }
      var dec = e.target.closest('[data-qty-dec]');
      if (dec) { e.preventDefault(); state.qty = Math.max(1, state.qty - 1); render(); return; }
      var stickyAdd = e.target.closest('[data-sticky-add]');
      if (stickyAdd) {
        e.preventDefault();
        var submit = qs('form[data-ajax-cart] [type="submit"]', buy);
        if (submit) submit.click();
      }
    });

    render();
    // Fin de promo pendant la visite (promo-bar.js) : recalcul sans le %
    document.addEventListener('bellori:promo-end', render);
  }

  /* ---------- Avis : jamais de carte sans photo ----------
     Si une photo Loox ne charge pas, on retire la carte et on révèle une carte de réserve. */
  function reviewImgFailed(img) {
    var card = img.closest('[data-review-card]');
    if (!card || card.hasAttribute('data-review-spare')) { if (card) card.remove(); return; }
    var grid = card.parentNode;
    card.remove();
    var spare = grid && grid.querySelector('[data-review-spare]');
    if (spare) { spare.removeAttribute('data-review-spare'); spare.hidden = false; }
  }
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.hasAttribute('data-review-img')) reviewImgFailed(img);
  }, true);
  qsa('img[data-review-img]').forEach(function (img) {
    if (img.complete && img.naturalWidth === 0 && img.src) reviewImgFailed(img);
  });

  /* ---------- Lightbox galerie produit ---------- */
  var lightbox = null;
  var lbIndex = 0;
  function lbItems() { return qsa('[data-lightbox]'); }
  function lbRender() {
    var items = lbItems();
    if (!items.length) return;
    lbIndex = (lbIndex + items.length) % items.length;
    qs('img', lightbox).src = items[lbIndex].getAttribute('data-lightbox');
    // alt = celui de l'image d'origine (accessibilité)
    var srcImg = items[lbIndex].tagName === 'IMG' ? items[lbIndex] : items[lbIndex].querySelector('img');
    qs('img', lightbox).alt = srcImg ? (srcImg.alt || '') : '';
    qs('.bl-lightbox__count', lightbox).textContent = (lbIndex + 1) + ' / ' + items.length;
  }
  function lbOpen(index) {
    lbIndex = index;
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'bl-lightbox';
      lightbox.innerHTML =
        '<img alt="">' +
        '<button type="button" class="bl-lightbox__close" aria-label="Fermer">×</button>' +
        '<button type="button" class="bl-lightbox__nav bl-lightbox__nav--prev" aria-label="Précédent">‹</button>' +
        '<button type="button" class="bl-lightbox__nav bl-lightbox__nav--next" aria-label="Suivant">›</button>' +
        '<span class="bl-lightbox__count"></span>';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target.closest('.bl-lightbox__nav--prev')) { lbIndex--; lbRender(); return; }
        if (e.target.closest('.bl-lightbox__nav--next')) { lbIndex++; lbRender(); return; }
        if (e.target.tagName !== 'IMG') lbClose();
      });
    }
    lightbox.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    lbRender();
  }
  function lbClose() {
    if (lightbox) lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest('[data-lightbox]');
    if (!img) return;
    e.preventDefault();
    lbOpen(lbItems().indexOf(img));
  });
  document.addEventListener('keydown', function (e) {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === 'Escape') lbClose();
    if (e.key === 'ArrowLeft') { lbIndex--; lbRender(); }
    if (e.key === 'ArrowRight') { lbIndex++; lbRender(); }
  });

  /* ---------- Description SEO — lire la suite ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-seo-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = t.closest('.bl-seo-desc');
    if (!box) return;
    box.classList.toggle('is-open');
    t.textContent = box.classList.contains('is-open') ? 'Réduire' : 'Lire la suite';
  });

  /* ---------- Tri de collection ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Filtres collection (taille / éclairage / prix) ---------- */
  function applyCollectionFilters() {
    var sizeSel = qs('[data-filter-size]');
    var lightSel = qs('[data-filter-light]');
    var priceSel = qs('[data-filter-price]');
    if (!sizeSel && !lightSel && !priceSel) return;
    var size = sizeSel ? sizeSel.value : '';
    var light = lightSel ? lightSel.value : '';
    var price = priceSel ? priceSel.value : '';
    var visible = 0;
    qsa('[data-product-card]').forEach(function (card) {
      var sizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean).map(Number);
      var prices = (card.getAttribute('data-prices') || '').split(',').filter(Boolean).map(Number);
      var ok = true;
      if (size) {
        ok = sizes.some(function (w) {
          if (size === 'small') return w <= 60;
          if (size === 'mid') return w > 60 && w < 80;
          if (size === 'large') return w >= 80;
          return true;
        });
      }
      if (ok && light && card.getAttribute('data-light') !== light) ok = false;
      if (ok && price) {
        var range = price.split('-').map(Number);
        ok = prices.some(function (p) { return p >= range[0] && p <= range[1]; });
      }
      card.style.display = ok ? '' : 'none';
      if (ok) visible++;
    });
    var empty = qs('[data-filter-empty]');
    if (empty) empty.hidden = visible > 0;
    var count = qs('[data-filter-count]');
    if (count) count.textContent = visible + (visible > 1 ? ' modèles' : ' modèle');
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-filter-size], [data-filter-light], [data-filter-price]')) applyCollectionFilters();
  });
  document.addEventListener('click', function (e) {
    var reset = e.target.closest('[data-filter-reset]');
    if (!reset) return;
    e.preventDefault();
    qsa('[data-filter-size], [data-filter-light], [data-filter-price]').forEach(function (sel) { sel.value = ''; });
    applyCollectionFilters();
  });
})();
